import { call, put } from 'redux-saga/effects';
import { setSidebar } from 'src/redux/commonRedux/actions';
import { APIHandler, AuthHandler } from '../commonHandlers';

function* signIn(api, action) {
  yield call(AuthHandler, api, action);
}

function* signOut(api, action) {
  yield call(AuthHandler, api, action);
  yield put(setSidebar(false));
}

function* getPermission(api, action) {
  yield call(APIHandler, api, action);
}

function* exchangeToken(api, action) {
  yield call(APIHandler, api, action);
}

function* changePassword(api, action) {
  yield call(AuthHandler, api, action);
}

export default {
  signIn,
  signOut,
  getPermission,
  exchangeToken,
  changePassword,
};
